import { use, useEffect, useState } from "react";
import contractServices from "../Contracts/contractServices";
import IndicatorDetail from "./IndicatorDetail";
import IndicatorChart from "./IndicatorChart";

export default function IndicatorSummary(detail: any) {

    let [indicatorValue, SetIndicatorValue] = useState<any>([])

    let [indicatorDetail, SetindicatorDetail] = useState(false);
    let [indicatorChartDetail, SetindicatorChartDetail] = useState(false);
    let [indicatorSelected, SetindicatorSelected] = useState("")
    let [passParm, SetpassParm] = useState<any>([])

    useEffect(() => {
        //search();
        console.log("passParm")
        console.log(passParm)
        if (passParm.length == 0 && passParm?.contract != detail?.paramDetail?.contract && passParm?.period?.periodDesc != detail?.paramDetail?.contract) {
            apiCall()
            passParm = detail?.paramDetail
            SetpassParm(passParm)
        }

    }, [detail]);


    const apiCall = () => {
        if (detail?.paramDetail?.contract) {
            var payload = {
                contractRefNum: detail?.paramDetail?.contract,
                periodNum: detail?.paramDetail?.period?.periodDesc
            }
            contractServices.contractIndicators(payload).then((respond: any) => {
                indicatorValue = respond
                SetIndicatorValue(indicatorValue)
            })
        }
    }

    const closeIndicatorDrawer = (e: any) => {
        indicatorDetail = false;
        SetindicatorDetail(indicatorDetail);
    }

    const closeIndicatorChartDrawer = (e: any) => {
        indicatorChartDetail = false;
        SetindicatorChartDetail(indicatorChartDetail);
    }


    return (
        <>

            {(() => {
                if (detail.paramDetail.type == "ContractTop") {

                    return (

                        <div className="ws-12">
                            <div className="w-14 pm">
                                <div className="topFrame topFrame_paleBlue ws-12 pull-left ">
                                    <label className="ws-12 text-left mts text-bold">Period Balance</label>
                                    <div className="label-entries ws-12 text-m mtl mb text-right text-bold">
                                        <span className="ws-12" onClick={() => { SetindicatorSelected("Period Balance"); SetindicatorDetail(true) }}>{(indicatorValue?.beginBalance ?? 0.00).toFixed(2)}</span>
                                    </div>
                                </div>
                            </div>

                            <div className="w-14 pm">
                                <div className="topFrame topFrame_darkBlue ws-12 pull-left ">
                                    <label className="ws-12 text-left mts text-bold">Last Payment  </label>
                                    <div className="label-entries ws-12 text-m mtl mb text-right text-bold">
                                        <span className="ws-12" onClick={() => { SetindicatorSelected("payments"); SetindicatorDetail(true) }}>{(indicatorValue?.lastPayment ?? 0.00).toFixed(2)}</span>
                                    </div>
                                </div>
                            </div>

                            <div className="w-14 pm">
                                <div className="topFrame topFrame_turquoise ws-12 pull-left">
                                    <label className="ws-12 text-left mts text-bold">Opening Balance
                                    </label>
                                    <div className="label-entries ws-12 text-m mtl mb text-right text-bold">
                                        <span className="ws-12">{(indicatorValue?.openingBalance ?? 0.00).toFixed(2)}</span>
                                    </div>
                                </div>
                            </div>

                            <div className="w-14 pm">
                                <div className="topFrame topFrame_purple ws-12 pull-left ">
                                    <label className="ws-12 text-left mts text-bold">Earnings </label>
                                    <div className="label-entries ws-12 text-m mtl mb text-right text-bold">
                                        <span className="ws-12" onClick={() => { SetindicatorSelected("Earnings"); SetindicatorDetail(true) }}>{(indicatorValue?.totalEarnings ?? 0.00).toFixed(2)}</span>
                                    </div>
                                </div>
                            </div>

                            <div className="w-14 pm">
                                <div className="topFrame topFrame_orange ws-12 pull-left ">
                                    <label className="ws-12 text-left mts text-bold"> Recoupables </label>
                                    <div className="label-entries ws-12 text-m mtl mb text-right text-bold">
                                        <span className="ws-12" onClick={() => { SetindicatorSelected("costs"); SetindicatorDetail(true) }}>{(indicatorValue?.totalCosts ?? 0.00).toFixed(2)}</span>
                                    </div>
                                </div>
                            </div>

                            <div className="w-14 pm">
                                <div className="topFrame topFrame_green ws-12 pull-left ">
                                    <label className="ws-12 text-left mts text-bold">Adjustments  </label>
                                    <div className="label-entries ws-12 text-m mtl mb text-right text-bold">
                                        <span className="ws-12" onClick={() => { SetindicatorSelected("adjustments"); SetindicatorDetail(true) }}>{(indicatorValue?.totalAdjustments ?? 0.00).toFixed(2)}</span>
                                    </div>
                                </div>
                            </div>

                            <div className="w-14 pm">
                                <div className="topFrame topFrame_paleBlue ws-12 pull-left ">
                                    <label className="ws-12 text-left mts text-bold">
                                        Total Balance
                                    </label>
                                    <div className="label-entries ws-12 text-m mtl mb text-right text-bold">
                                        <span className="ws-12" onClick={() => { SetindicatorSelected("Period Balance"); SetindicatorChartDetail(true) }}>{(indicatorValue?.endBalance ?? 0.00).toFixed(2)}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }

                if (detail.paramDetail.type == "ContractLeft") {
                    return (
                        <div className="ws-12">

                            <div className="ws-11 leftFrameGreen landing mt pLarge">
                                <span className="ws-12 text-bold">Total for the project</span>

                                <div className="ws-12">
                                    <span className="ws-6 pts pull-left">{detail?.paramDetail?.homeCurrency} {(indicatorValue?.endBalance ?? 0.00).toFixed(2)}</span>
                                    <span className="ws-6 pts pull-right text-right" onClick={() => { SetindicatorSelected("Period Balance"); SetindicatorChartDetail(true) }}>...</span>
                                </div>
                            </div>

                            <div className="ws-11 leftFrameGreen landing mt pLarge">
                                <span className="ws-12 text-bold" > Payments </span>

                                <div className="ws-12">
                                    <span className="ws-6 pts">{detail?.paramDetail?.homeCurrency} {(indicatorValue?.openingBalance ?? 0.00).toFixed(2)}</span>
                                    <span className="ws-6 pts pull-right text-right" onClick={() => { SetindicatorSelected("payments"); SetindicatorDetail(true) }}>...</span>
                                </div>
                            </div>

                            <div className="ws-11 leftFrameGreen landing mt pLarge">
                                <span className="ws-12 text-bold">Lifetime Royalties</span>

                                <div className="ws-12">
                                    <span className="ws-6 pts">{detail?.paramDetail?.homeCurrency} {(indicatorValue?.lifetimeroyalty ?? 0.00).toFixed(2)}</span>
                                    <span className="ws-6 pts pull-right text-right" onClick={() => { SetindicatorSelected("Earnings"); SetindicatorDetail(true) }}>...</span>
                                </div>
                            </div>

                            <div className="ws-11 leftFrameGreen landing mt pLarge hide">
                                <span className="ws-12 text-bold">Lifetime Royalties - Third Parties </span>

                                <div className="ws-12">
                                    <span className="ws-6 pts"> {detail?.paramDetail?.homeCurrency} {(indicatorValue?.lifetimeroyaltyThirdParties ?? 0.00).toFixed(2)}</span>
                                    <span className="ws-6 pts pull-right text-right">...</span>
                                </div>
                            </div>

                            <div className="ws-11 leftFrameGreen landing mt pLarge">
                                <span className="wws-12 text-bold">Lifetime Recoupables</span>

                                <div className="ws-12">
                                    <span className="ws-6 pts"> {detail?.paramDetail?.homeCurrency} {(indicatorValue?.totalCosts ?? 0.00).toFixed(2)}</span>
                                    <span className="ws-6 pts pull-right text-right" onClick={() => { SetindicatorSelected("costs"); SetindicatorDetail(true) }}>...</span>

                                </div>
                            </div>

                        </div>
                    )
                }

            })()}


            <>
                {(() => {

                    if (indicatorDetail) {
                        return <IndicatorDetail paramDetail={detail?.paramDetail} indicatorDetail={indicatorDetail} indicatorSelected={indicatorSelected} closeIndicatorDrawer={closeIndicatorDrawer} />
                    }

                    if (indicatorChartDetail) {
                        return <IndicatorChart paramDetail={detail?.paramDetail} indicatorChartDetail={indicatorChartDetail} indicatorSelected={indicatorSelected} closeIndicatorChartDrawer={closeIndicatorChartDrawer} />
                    }


                })()}
            </>
        </>
    )

}